import { LoaderFunction } from 'react-router-dom';
import { client } from '~/api/client';
import { queryData } from '~/api/data/request';
import { loadQuery } from '~/api/data/responses';
import {
  AcordFormConfigurationFieldsFragment,
  ChildAgencyFieldsFragment,
  FederatedChildAgencyFieldsFragment,
  GetAgencyProducerInformationsDocument,
  GetAgencyProducerInformationsQuery,
  GetAgencyProducerInformationsQueryVariables,
  GetChildAgenciesDocument,
  GetChildAgenciesQuery,
  GetChildAgenciesQueryVariables,
  GetDefaultAcordFormConfigurationDocument,
  GetDefaultAcordFormConfigurationQuery,
  GetDefaultAcordFormConfigurationQueryVariables,
  GetFederatedChildAgenciesDocument,
  GetFederatedChildAgenciesQuery,
  GetFederatedChildAgenciesQueryVariables,
  ProducerInformationFieldsFragment
} from '~/api/graphql';

// Agencies store only overrides; settings resolve null fields against this default.
export const getDefaultACORDFormConfiguration = async () =>
  queryData<
    GetDefaultAcordFormConfigurationQuery,
    GetDefaultAcordFormConfigurationQueryVariables,
    AcordFormConfigurationFieldsFragment
  >(
    client,
    { query: GetDefaultAcordFormConfigurationDocument },
    (data) => data?.defaultACORDFormConfiguration
  );

export const getAgencyProducerInformations = async () =>
  queryData<
    GetAgencyProducerInformationsQuery,
    GetAgencyProducerInformationsQueryVariables,
    ProducerInformationFieldsFragment[]
  >(
    client,
    { query: GetAgencyProducerInformationsDocument, fetchPolicy: 'network-only' },
    (data) => data?.agencyUser?.agency?.producerInformations || []
  );

export const getChildAgencies = async () => {
  return queryData<
    GetChildAgenciesQuery,
    GetChildAgenciesQueryVariables,
    ChildAgencyFieldsFragment[]
  >(
    client,
    { query: GetChildAgenciesDocument },
    (data) => data?.agencyUser?.agency.childAgencies || []
  );
};

/** Child agencies with FEDERATED_BILLING that the caller can share presets with. */
export const getFederatedChildAgencies = async () =>
  queryData<
    GetFederatedChildAgenciesQuery,
    GetFederatedChildAgenciesQueryVariables,
    FederatedChildAgencyFieldsFragment[]
  >(
    client,
    { query: GetFederatedChildAgenciesDocument },
    (data) => data?.federatedChildAgencies || []
  );

export const loadFederatedChildAgencies: LoaderFunction = () =>
  loadQuery(getFederatedChildAgencies(), {
    suppressAuthErrors: true
  });

export const loadAgencyProducerInformations: LoaderFunction = () =>
  loadQuery(getAgencyProducerInformations(), {
    notFoundRedirect: '/app/signin',
    suppressAuthErrors: true
  });

export const loadDefaultACORDFormConfiguration: LoaderFunction = () =>
  loadQuery(getDefaultACORDFormConfiguration(), { notFoundRedirect: '/app/signin' });

export const loadChildAgencies: LoaderFunction = () =>
  loadQuery(getChildAgencies(), {
    notFoundRedirect: '/app/signin',
    suppressAuthErrors: true
  });
